<template>
  <b-card :title="$t('widget.question_mark.settings')">
    <form ref="form" class="content" @submit.prevent="saveSettings">
      <fields />
      <b-button type="submit" variant="primary">
        {{ $t('general.save') }}
      </b-button>
    </form>
  </b-card>
</template>

<script>
import { FormMixin } from 'stylemix-base'

export default {
  name: 'QuestionMarkSettingsForm',

  mixins: [FormMixin],

  data() {
    return {
      model: {},
      settingsList: null,
    }
  },

  computed: {
    settings() {
      return []
    },
  },

  mounted() {
    this.$uiBlocker(this.fetchSettings(), this.$el)
  },

  methods: {
    fetchSettings() {
      return this.$http.get('/widget/settings').then(({ data }) => {
        this.setFields(data.fields)
        this.model = data.data
      })
    },

    saveSettings() {
      const allOptions = this.fields.list[0].options.map(({ value }) => value)

      const optionsForSave = {}
      allOptions.forEach(option => {
        optionsForSave[option] = this.model.widget.includes(option)
      })

      const promise = this.$http
        .post('/widget/store', { widget: optionsForSave })
        .then(response => this.$toast.success(response.data.message))
        .catch(err => this.$toast.error(err.response.data.message))

      this.$uiBlocker(promise, this.$el)
    },
  },
}
</script>

<style scoped></style>
